export const Actions = {
    VALIDATE: 'VALIDATE',
    VALIDATE_FULLFILLED: 'VALIDATE_FULLFILLED',
    VALIDATE_REJECTED: 'VALIDATE_REJECTED',
    VALIDATE_PENDING: 'VALIDATE_PENDING',
}